import { ActionTypes } from 'constants/index';
import { REHYDRATE } from 'redux-persist';

const initialState = {
    isAuthenticated: false,
    userDetailsLoading: false,
    ssoExpired: false
};

// Helper function to restore user data from localStorage
const restoreUserFromLocalStorage = () => {
    try {
        const jwtuserData = localStorage.getItem('jwtuserData');
        const jwt_access_token = localStorage.getItem('jwt_access_token');
        
        if (jwtuserData && jwt_access_token) {
            const userData = JSON.parse(jwtuserData);
            if (userData && Object.keys(userData).length > 0) {
                return {
                    ...initialState,
                    ...userData,
                    isAuthenticated: true
                };
            }
        }
    } catch (error) {
        console.error('Error restoring user from localStorage:', error);
    }
    return null;
};

const user = function (state = initialState, action) {
    switch (action.type) {
        case REHYDRATE:
            {
                // When redux-persist rehydrates, check if we need to restore from localStorage
                const persistedState = action.payload?.user;
                
                // If persisted state exists and has user data, use it
                if (persistedState && persistedState.isAuthenticated && persistedState._id) {
                    // Clear manualLogout on page refresh - allows LLSE to auto-login
                    // after user refreshes browser (even if they manually logged out before)
                    return {
                        ...persistedState,
                        manualLogout: false
                    };
                }
                
                // Otherwise, try to restore from localStorage
                const restoredUser = restoreUserFromLocalStorage();
                if (restoredUser) {
                    return {
                        ...restoredUser,
                        manualLogout: false  // Also clear here
                    };
                }
                
                // Fall back to persisted state or initial state
                // Clear manualLogout here too for consistency
                return {
                    ...(persistedState || initialState),
                    manualLogout: false
                };
            }
        case ActionTypes.SET_USER_DATA:
            {
                return {
                    ...initialState,
                    ...action.payload,
                    isAuthenticated: true
                };
            }
        case ActionTypes.REMOVE_USER_DATA:
            {
                return {
                    ...initialState
                };
            }
        case ActionTypes.SET_ORG_ID_TO_USER_OBJ: {
            return {
                ...state,
                orgId: action.payload,
            };
        }
        case ActionTypes.USER_LOGGED_OUT: {
            return initialState;
        }
        case ActionTypes.SET_USER_DETAILS_LOADING: {
            return {
                ...state,
                userDetailsLoading: action.payload,
            };
        }
        case ActionTypes.USER_SSO_EXPIRE: {
            return {
                ...state,
                ssoExpired: true,
            };
        }
        case ActionTypes.USER_SSO_RESET: {
            return {
                ...state,
                ssoExpired: false,
            };
        }
        default:
            {
                return state
            }
    }
};

export default user;
